var _path, _g, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarRentalsStep3 = function SvgCarRentalsStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 164,
    viewBox: "0 0 160 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5981 163.41C145.757 163.41 152.423 145.404 152.423 81.8199C152.423 18.2357 145.757 0.229492 76.5981 0.229492C7.43934 0.229492 0.773438 18.2357 0.773438 81.8199C0.773438 145.404 7.43934 163.41 76.5981 163.41Z",
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8168_49027)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8168_49027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.657 163.597H55.4429C53.8362 163.597 52.5508 161.93 52.5508 159.847V27.3467C52.5508 25.2633 53.8362 23.5967 55.4429 23.5967H125.497C127.103 23.5967 128.389 25.2633 128.389 27.3467V159.847C128.389 161.93 127.103 163.597 125.657 163.597Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.965 112.653H61.8898C61.4078 112.653 60.9258 112.167 60.9258 111.68V111.356C60.9258 110.87 61.4078 110.384 61.8898 110.384H117.965C118.447 110.384 118.929 110.87 118.929 111.356V111.68C118.929 112.167 118.608 112.653 117.965 112.653Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.965 119.623H61.8898C61.4078 119.623 60.9258 119.136 60.9258 118.65V118.326C60.9258 117.84 61.4078 117.354 61.8898 117.354H117.965C118.447 117.354 118.929 117.84 118.929 118.326V118.65C118.929 119.136 118.608 119.623 117.965 119.623Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5111 126.429H62.0505C61.4078 126.429 60.9258 125.943 60.9258 125.295C60.9258 124.646 61.4078 124.16 62.0505 124.16H76.5111C77.1538 124.16 77.6359 124.646 77.6359 125.295C77.6359 125.943 77.1538 126.429 76.5111 126.429Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5111 104.874H62.0505C61.4078 104.874 60.9258 104.387 60.9258 103.739C60.9258 103.091 61.4078 102.604 62.0505 102.604H76.5111C77.1538 102.604 77.6359 103.091 77.6359 103.739C77.6359 104.387 77.1538 104.874 76.5111 104.874Z",
    fill: "#DFDFDF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.0508,
    y: 22.0967,
    width: 59.8194,
    height: 107.52,
    rx: 7.5,
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.836 125.022C145.836 127.986 144.566 130.857 142.417 132.988C141.928 133.451 141.244 134.006 140.658 134.47C138.704 135.674 136.555 136.322 134.112 136.322H108.026H92.8823C86.3363 136.322 81.1582 131.32 81.1582 125.207C81.1582 122.243 82.4283 119.372 84.5777 117.334C86.8249 115.204 89.7559 114 92.8823 114L134.112 113.814C140.463 113.814 145.738 118.909 145.836 125.022Z",
    fill: "#59CF1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.901 124.284C132.509 124.284 132.215 123.991 132.215 123.599V120.664C132.215 120.272 132.509 119.979 132.901 119.979C133.293 119.979 133.587 120.272 133.587 120.664V123.599C133.489 123.991 133.195 124.284 132.901 124.284Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.132 125.656C135.936 125.656 135.838 125.558 135.642 125.46C135.348 125.166 135.348 124.775 135.642 124.481L137.798 122.329C138.092 122.035 138.484 122.035 138.778 122.329C139.072 122.622 139.072 123.014 138.778 123.307L136.622 125.46C136.524 125.558 136.328 125.656 136.132 125.656Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.175 125.655C128.979 125.655 128.783 125.557 128.685 125.459L127.607 124.382C127.313 124.089 127.313 123.697 127.607 123.404C127.901 123.11 128.293 123.11 128.587 123.404L129.665 124.48C129.959 124.774 129.959 125.165 129.665 125.459C129.469 125.655 129.371 125.655 129.175 125.655Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.17 129.081H137.014C136.622 129.081 136.328 128.787 136.328 128.396C136.328 128.005 136.622 127.711 137.014 127.711H139.17C139.562 127.711 139.856 128.005 139.856 128.396C139.856 128.787 139.562 129.081 139.17 129.081Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.613 102.658C117.025 102.658 116.535 102.169 116.535 101.582V96.2972C116.535 95.71 117.025 95.2207 117.613 95.2207C118.201 95.2207 118.691 95.71 118.691 96.2972V101.582C118.593 102.169 118.103 102.658 117.613 102.658Z",
    fill: "#FF8000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.967 141.215C158.869 141.215 158.771 141.215 158.673 141.117L153.577 139.747C153.087 139.649 152.695 139.062 152.891 138.475C152.989 137.985 153.577 137.594 154.165 137.79L159.261 139.16C159.751 139.258 160.143 139.845 159.947 140.432C159.849 140.921 159.359 141.215 158.967 141.215Z",
    fill: "#FF8000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2586 137.398C75.7687 137.398 75.3767 137.104 75.2787 136.517C75.1807 135.93 75.5727 135.343 76.1607 135.343L78.0226 135.049C78.6106 134.951 79.1006 135.343 79.1986 135.93C79.2966 136.517 78.9046 137.104 78.3166 137.104L76.4546 137.398C76.3566 137.398 76.3566 137.398 76.2586 137.398Z",
    fill: "#FF8000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3384 138.181C71.8484 138.181 71.4564 137.887 71.3584 137.3C71.2604 136.713 71.5544 136.126 72.1424 136.028L72.7304 135.93C73.3184 135.832 73.8083 136.224 73.9063 136.811C74.0043 137.398 73.6123 137.887 73.1224 138.083L72.5344 138.181C72.5344 138.181 72.4364 138.181 72.3384 138.181Z",
    fill: "#FF8000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7263 113.031C82.6283 113.031 82.5303 112.933 82.4323 112.933L76.1605 108.725C75.6705 108.432 75.5726 107.747 75.8665 107.258C76.1605 106.768 76.8465 106.67 77.3365 106.964L83.6083 111.172C84.0983 111.465 84.1963 112.15 83.9023 112.64C83.6083 113.031 83.2163 113.129 82.7263 113.031Z",
    fill: "#FF8000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.304 120.077C151.814 120.077 151.422 119.783 151.324 119.196C151.226 118.609 151.618 118.12 152.206 118.022L157.301 117.141C157.889 117.043 158.379 117.435 158.477 118.022C158.575 118.609 158.183 119.196 157.595 119.196L152.5 120.077C152.304 120.077 152.304 120.077 152.304 120.077Z",
    fill: "#FF8000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M135.45 109.41C135.156 109.41 134.96 109.312 134.764 109.116C134.274 108.725 134.274 108.04 134.666 107.648L137.409 104.517C137.801 104.126 138.487 104.028 138.879 104.419C139.369 104.811 139.369 105.496 138.977 105.887L136.234 109.018C136.038 109.312 135.842 109.41 135.45 109.41Z",
    fill: "#FF8000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.741 103.539C140.447 103.539 140.251 103.441 140.055 103.245C139.663 102.854 139.565 102.168 139.957 101.777L141.329 100.211C141.721 99.8199 142.406 99.722 142.798 100.113C143.19 100.505 143.288 101.19 142.896 101.581L141.525 103.147C141.329 103.343 141.035 103.539 140.741 103.539Z",
    fill: "#FF8000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.888 148.848C114.084 148.75 114.378 148.652 114.574 148.652C115.162 148.75 115.554 149.142 115.456 149.729L115.162 153.937C115.064 154.524 114.672 154.915 114.084 154.817C113.496 154.72 113.105 154.328 113.203 153.643L113.496 149.435C113.496 149.337 113.594 149.044 113.888 148.848Z",
    fill: "#FF8000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.302 156.775C113.498 156.677 113.792 156.579 113.988 156.579C114.576 156.677 114.968 157.068 114.87 157.753L114.772 159.808C114.674 160.396 114.282 160.787 113.694 160.689C113.106 160.591 112.714 160.2 112.812 159.515L112.91 157.46C112.812 157.264 113.008 156.971 113.302 156.775Z",
    fill: "#FF8000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9181 146.988C93.2121 146.988 93.4081 147.086 93.6041 147.282C94.094 147.673 94.094 148.358 93.702 148.75L90.9581 151.881C90.5661 152.273 89.8802 152.371 89.4882 151.979C88.9982 151.588 88.9982 150.903 89.3902 150.511L92.1341 147.38C92.3301 147.184 92.6241 146.988 92.9181 146.988Z",
    fill: "#FF8000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9949 108.236C98.7009 108.236 98.3089 108.138 98.1129 107.747L96.349 105.202C96.055 104.713 96.153 104.028 96.643 103.734C97.1329 103.441 97.7209 103.539 98.1129 104.028L99.9749 106.572C100.269 107.062 100.171 107.747 99.6809 108.04C99.3869 108.236 99.1909 108.236 98.9949 108.236Z",
    fill: "#FF8000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.091 128.102C123.396 128.457 123.33 128.986 122.971 129.273C122.815 129.411 122.627 129.471 122.434 129.471C122.196 129.471 121.967 129.361 121.803 129.169L121.797 129.161L119.398 126.031L118.391 127.053V128.634C118.391 129.09 118.023 129.471 117.549 129.471C117.075 129.471 116.707 129.09 116.707 128.634V121.794C116.707 121.352 117.072 120.956 117.549 120.956C118.026 120.956 118.391 121.352 118.391 121.794V124.678L121.861 121.212C122.196 120.879 122.719 120.879 123.054 121.212C123.378 121.535 123.374 122.066 123.057 122.396L123.053 122.4L120.592 124.84L123.091 128.102Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7986 129.471C91.8063 129.471 91.8142 129.471 91.8221 129.47C91.83 129.471 91.8379 129.471 91.8455 129.471H93.924C95.4183 129.471 96.6326 128.261 96.6326 126.763C96.6326 125.875 96.1881 125.088 95.5229 124.597C95.7582 124.224 95.8928 123.788 95.8928 123.314C95.8928 121.979 94.8071 120.898 93.466 120.898H91.7986C91.3405 120.898 90.957 121.263 90.957 121.736V128.634C90.957 129.092 91.3382 129.471 91.7986 129.471ZM91.1527 128.634C91.1527 128.943 91.3816 129.207 91.6776 129.265C91.7169 129.273 91.7573 129.277 91.7986 129.277C91.4463 129.277 91.1527 128.984 91.1527 128.634ZM92.6519 122.585H93.466C93.8746 122.585 94.198 122.907 94.198 123.314C94.198 123.727 93.8683 124.066 93.466 124.066H92.6519V122.585ZM92.6519 125.754H93.9222C94.4885 125.764 94.9377 126.208 94.9377 126.763C94.9377 127.331 94.4872 127.773 93.9222 127.784H92.6519V125.754Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.565 120.664C100.382 120.664 99.2975 121.167 98.5453 121.977C97.784 122.784 97.3303 123.86 97.3303 125.068C97.3303 126.274 97.7834 127.363 98.5463 128.159C99.2972 128.956 100.381 129.471 101.565 129.471C102.703 129.471 103.787 128.956 104.515 128.158C105.275 127.364 105.754 126.276 105.754 125.068C105.754 123.858 105.275 122.783 104.516 121.978C103.787 121.167 102.702 120.664 101.565 120.664ZM103.279 126.968L103.278 126.969C102.817 127.461 102.209 127.749 101.565 127.749C100.873 127.749 100.266 127.459 99.8062 126.969L99.8031 126.966C99.3474 126.501 99.0603 125.814 99.0603 125.068C99.0603 124.321 99.3472 123.633 99.8047 123.156L99.8062 123.155C100.264 122.666 100.871 122.387 101.565 122.387C102.211 122.387 102.818 122.665 103.278 123.155C103.726 123.634 104.023 124.323 104.023 125.068C104.023 125.813 103.726 126.501 103.279 126.968Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.192 120.664C110.009 120.664 108.924 121.167 108.172 121.977C107.411 122.784 106.957 123.86 106.957 125.068C106.957 126.274 107.41 127.363 108.173 128.159C108.924 128.956 110.008 129.471 111.192 129.471C112.33 129.471 113.414 128.956 114.142 128.158C114.902 127.364 115.381 126.276 115.381 125.068C115.381 123.858 114.902 122.783 114.143 121.978C113.414 121.167 112.329 120.664 111.192 120.664ZM112.906 126.968L112.905 126.969C112.444 127.461 111.836 127.749 111.192 127.749C110.5 127.749 109.893 127.459 109.433 126.969L109.43 126.966C108.974 126.501 108.687 125.814 108.687 125.068C108.687 124.321 108.974 123.633 109.432 123.156L109.433 123.155C109.891 122.666 110.498 122.387 111.192 122.387C111.838 122.387 112.445 122.665 112.905 123.155C113.353 123.634 113.651 124.323 113.651 125.068C113.651 125.813 113.353 126.501 112.906 126.968Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.768 143.381L132.894 129.656C132.413 129.212 131.634 129.549 131.628 130.203L131.445 150.427C131.44 150.98 132.01 151.35 132.513 151.121L137.011 149.071C137.526 148.836 138.127 149.125 138.265 149.674L139.699 155.377C139.815 155.841 140.329 156.081 140.759 155.873L145.59 153.533C146.024 153.323 146.152 152.767 145.855 152.388L142.397 147.976C142.026 147.503 142.211 146.806 142.768 146.579L147.541 144.634C148.052 144.426 148.174 143.755 147.768 143.381Z",
    fill: "#44B50C",
    stroke: "#44B50C",
    strokeWidth: 2.62156
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64471 7.01846C6.33355 7.80478 7.11301 9.77057 6.46345 11.4743C5.68399 13.1779 3.73533 13.9643 2.04649 13.309C0.357649 12.5227 -0.421829 10.5569 0.227726 8.8532C0.87728 7.01846 2.95587 6.23215 4.64471 7.01846Z",
    fill: "#59CF1E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15119 1.38267C8.67083 0.203201 9.96995 -0.321011 11.1391 0.203199C12.3083 0.72741 12.828 2.03794 12.3083 3.21741C11.7887 4.39688 10.4896 4.92109 9.32039 4.39688C8.15119 4.00373 7.63155 2.56215 8.15119 1.38267Z",
    fill: "#59CF1E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8168_49027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1251 114.24L62.7991 114.563C64.9691 114.606 66.6959 112.881 66.7358 110.71L66.8994 82.1544C66.9393 79.9829 65.2132 78.2523 63.0432 78.2093L14.29 77.9096C12.12 77.8666 10.3932 79.5916 10.3532 81.7631L10.1897 110.319C10.2289 112.466 11.9788 114.276 14.1251 114.24Z",
    fill: "url(#paint0_linear_8168_49027)"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0909 107.354C64.0117 107.377 63.9325 107.401 63.8533 107.425L46.8261 107.326C46.3826 107.286 46.0262 106.96 45.9867 106.54C46.0264 106.097 46.3512 105.74 46.7709 105.701L63.7981 105.8C64.2416 105.84 64.5979 106.166 64.6374 106.586C64.6532 106.927 64.4077 107.259 64.0909 107.354Z",
    fill: "url(#paint1_linear_8168_49027)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5367 102.109C60.4575 102.133 60.3783 102.156 60.2991 102.18L40.0565 102.005C39.613 101.965 39.2567 101.639 39.2172 101.219C39.2569 100.775 39.5816 100.419 40.0014 100.38L60.2439 100.555C60.6874 100.595 61.0438 100.921 61.0833 101.341C61.0991 101.682 60.8535 102.014 60.5367 102.109Z",
    fill: "url(#paint2_linear_8168_49027)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2032 101.664C30.3616 101.617 30.4408 101.593 30.5755 101.467C30.9794 101.087 31.13 100.437 30.75 100.033C30.0215 99.0408 29.5862 97.875 29.6497 96.6467C29.7133 95.4183 30.1412 94.254 30.9016 93.3358C31.2819 92.8767 31.1711 92.2187 30.8148 91.8932C30.3555 91.5121 29.6982 91.622 29.3734 91.9781C28.2882 93.2524 27.6622 94.9078 27.6619 96.6356C27.6616 98.3634 28.1602 100.029 29.245 101.346C29.4192 101.639 29.8072 101.783 30.2032 101.664Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8603 104.908C27.0187 104.861 27.0979 104.837 27.2326 104.71C27.6366 104.331 27.7079 103.705 27.3041 103.22C25.7126 101.363 24.8181 98.9525 24.8661 96.5195C24.914 94.0864 25.849 91.734 27.552 89.9297C27.9322 89.4706 27.9244 88.8683 27.4652 88.4871C27.0059 88.106 26.404 88.1129 26.0238 88.572C23.996 90.7325 22.8629 93.5759 22.7991 96.532C22.7352 99.4881 23.7721 102.375 25.7437 104.637C26.0208 104.986 26.4643 105.026 26.8603 104.908Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6539 108.027C23.8123 107.98 23.9707 107.932 24.0261 107.829C24.4301 107.45 24.5015 106.824 24.0977 106.34C21.7223 103.594 20.4161 100.096 20.4485 96.4586C20.4808 92.8208 21.9466 89.3597 24.4338 86.7165C24.8378 86.3368 24.8062 85.6551 24.4261 85.2503C24.0461 84.8455 23.365 84.8761 22.961 85.2559C20.0698 88.2788 18.4852 92.2074 18.4369 96.3682C18.3886 100.529 19.8372 104.502 22.5927 107.653C22.8698 108.002 23.3371 108.122 23.6539 108.027Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3322 88.47C61.3536 86.3222 59.631 84.5614 57.4848 84.537C55.3386 84.5125 53.5815 86.2339 53.5601 88.3816C53.5388 90.5294 55.2613 92.2903 57.4075 92.3147C59.5537 92.3391 61.3109 90.6178 61.3322 88.47Z",
    fill: "#9C9C9C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3861 92.0637C55.4419 91.4498 56.6088 89.2836 55.9925 87.2253C55.3761 85.1671 53.2099 83.9962 51.1541 84.6101C49.0982 85.224 47.9313 87.3902 48.5476 89.4485C49.164 91.5067 51.3302 92.6776 53.3861 92.0637Z",
    fill: "url(#paint3_linear_8168_49027)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7159 66.9599L51.0942 65.9549C51.0942 65.9549 53.3944 55.6173 47.5626 56.6881C41.7328 57.7571 41.1861 63.6853 42.7159 66.9599Z",
    fill: "url(#paint4_linear_8168_49027)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.324 71.3324L94.8459 70.3387C94.8459 70.3387 97.1461 60.0011 91.3143 61.0719C85.4826 62.1428 84.8632 64.7305 86.324 71.3343V71.3324Z",
    fill: "url(#paint5_linear_8168_49027)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.688 65.4048C111.688 65.4048 115.514 63.393 117.99 63.3027C120.467 63.2142 122.355 64.6859 122.355 64.6859C122.355 64.6859 124.137 65.9355 123.739 67.8532C123.342 69.771 116.708 70.7533 113.037 70.1737C109.365 69.5941 109.675 68.4329 109.807 67.4975C109.94 66.5603 111.688 65.4048 111.688 65.4048Z",
    fill: "url(#paint6_linear_8168_49027)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2299 68.3891C97.0583 64.7682 94.1872 62.0714 91.1333 62.4233C90.1315 62.5381 92.7395 62.126 93.2525 62.126C99.7428 62.1222 100.989 73.1242 94.4801 74.2195L92.8925 74.4867C95.3737 74.0689 97.381 71.6054 97.2281 68.3891H97.2299Z",
    fill: "url(#paint7_linear_8168_49027)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9839 62.4031C89.0307 62.2074 86.598 64.7668 86.5477 68.1186C86.4973 71.4704 88.8498 74.346 91.803 74.5417C94.7562 74.7375 97.1888 72.178 97.2392 68.8262C97.2896 65.4745 94.9371 62.5988 91.9839 62.4031Z",
    fill: "url(#paint8_linear_8168_49027)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9555 64.3353C89.9426 64.2017 88.2841 65.9463 88.2505 68.231C88.2169 70.5157 89.8195 72.4767 91.8324 72.6084C93.8453 72.742 95.5038 70.9975 95.5374 68.7128C95.571 66.4281 93.9685 64.4689 91.9555 64.3353Z",
    fill: "url(#paint9_linear_8168_49027)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1035 60.144C46.943 60.0255 47.4337 59.873 48.0362 59.873C48.1221 59.873 48.2097 59.8749 48.2974 59.8806C50.7059 60.0405 52.6423 62.3911 52.6013 65.1407C52.5658 67.5402 51.0398 69.4428 49.0418 69.7778L47.7415 69.9961C49.7395 69.6592 51.2637 67.7566 51.301 65.359C51.3476 62.2443 48.8608 59.6792 46.1035 60.1422V60.144Z",
    fill: "url(#paint10_linear_8168_49027)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9967 60.0994C44.5789 59.9394 42.5847 62.0359 42.5436 64.7817C42.5026 67.5275 44.4297 69.8818 46.8475 70.0418C49.2652 70.2018 51.2595 68.1053 51.3006 65.3595C51.3416 62.6137 49.4145 60.2594 46.9967 60.0994Z",
    fill: "url(#paint11_linear_8168_49027)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.97 61.7928C45.3749 61.6874 44.0616 63.0687 44.0336 64.8792C44.0075 66.6896 45.2779 68.2422 46.8711 68.3476C48.4662 68.453 49.7795 67.0717 49.8075 65.2612C49.8355 63.4508 48.5632 61.8982 46.97 61.7928Z",
    fill: "url(#paint12_linear_8168_49027)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M100.381 54.7023C100.381 54.7023 87.8726 47.2441 82.2461 47.2441L97.734 54.5574L100.381 54.7023Z",
    fill: "url(#paint13_linear_8168_49027)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7305 54.5257L83.1158 55.0922C78.0881 50.5021 75.9744 48.4357 72.3906 47.6848L82.6363 47.252C89.4717 48.3567 97.9116 54.0853 98.7305 54.5257Z",
    fill: "url(#paint14_linear_8168_49027)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6363 64.6855C41.0785 66.0687 42.7146 66.9589 42.7146 66.9589C42.5019 66.2701 42.3098 65.2106 42.3694 64.1096C42.4832 62.015 43.5018 59.7679 47.0035 59.6531C49.9175 59.5553 51.0313 61.9152 51.6357 63.9534C51.7794 64.4389 51.8297 64.9283 51.8223 65.3987C51.8185 65.6076 51.8055 65.8128 51.7831 66.0104C51.6432 67.2506 51.1786 68.2047 51.1786 68.2047L86.3147 71.3326H86.3222C86.1617 70.1733 86.1132 69.0968 86.171 68.1408C86.2233 67.2525 86.3669 66.4696 86.5964 65.8222C87.8706 62.2389 91.4636 60.8896 94.8235 62.6323C97.4502 63.9967 98.161 66.8422 98.273 69.1043C98.3625 70.9185 98.0677 72.3582 98.0677 72.3582C118.289 74.4171 124.036 70.2279 124.036 70.2279V65.666C123.548 60.2723 116.546 57.8333 115.798 57.5867C121.695 59.5948 122.303 64.6271 122.356 64.6836C123.169 65.7319 123.553 67.1734 123.553 67.1734C123.193 67.8114 122.374 68.6696 120.828 69.0912C117.201 70.0811 112.711 69.9493 110.095 67.9921C110.261 67.2224 110.66 66.575 111.017 66.1195C111.373 65.6641 111.688 65.4025 111.688 65.4025C110.808 64.6817 109.214 62.3142 107.336 61.1963C106.401 60.6694 105.338 60.1104 104.114 59.655C101.237 58.5823 98.1797 58.0572 95.3142 57.662C92.4505 57.2687 89.7567 57.0748 87.5329 56.8716C86.4154 56.6984 85.3744 56.4877 84.9081 56.2524C83.6675 55.6295 78.0521 49.8086 74.8228 48.3802C71.5954 46.9537 66.1237 47.1249 61.0923 47.5333C53.8632 48.1205 48.6863 51.5231 47.0502 52.5487C45.4141 53.5744 43.25 54.5587 42.14 55.7161C41.1102 56.7925 40.6046 59.5515 40.4834 61.7797C40.4143 63.0689 40.474 64.1811 40.6363 64.6874V64.6855Z",
    fill: "url(#paint15_linear_8168_49027)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0885 59.7422C98.4094 59.4129 103.331 60.7604 105.122 61.6016C106.913 62.4428 109.739 64.0877 109.739 64.0877C109.739 64.0877 106.413 64.2646 103.262 63.7188C100.364 63.2182 97.4076 60.4404 98.0866 59.7403L98.0885 59.7422Z",
    fill: "url(#paint16_linear_8168_49027)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0898 59.7437C98.3193 59.3447 103.332 60.393 105.123 61.2342C106.914 62.0754 109.434 63.8595 109.434 63.8595C109.434 63.8595 106.349 63.7127 103.198 63.1689C100.3 62.6683 97.8249 60.2048 98.0898 59.7437Z",
    fill: "url(#paint17_linear_8168_49027)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4413 55.0937C84.1055 55.6809 84.6204 56.1062 84.9077 56.2511C85.374 56.4864 86.415 56.6991 87.5325 56.8703C91.7972 57.2599 95.7671 57.5365 100.013 58.4982C101.392 58.8106 102.774 59.1889 104.127 59.6594C107.281 60.7547 110.304 64.2664 111.686 65.4012C112.113 65.3109 112.529 65.2225 112.936 65.1359C116.273 64.4358 119.018 63.9615 122.353 64.6823C122.353 64.6823 121.566 59.5483 115.731 57.5648C109.895 55.5812 98.7296 54.5254 98.7296 54.5254L83.4395 55.0919L83.4413 55.0937Z",
    fill: "url(#paint18_linear_8168_49027)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2597 55.9401C74.6034 56.1734 56.6585 54.6359 54.8993 54.5004C53.1419 54.3668 49.5096 53.932 49.7261 52.3926L80.5097 54.9483L81.2578 55.9382L81.2597 55.9401Z",
    fill: "url(#paint19_linear_8168_49027)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6403 55.093C80.6403 55.093 75.0436 48.7131 69.8928 48.173C64.1095 47.567 54.2314 48.1579 49.9574 52.0235C48.9947 52.8929 51.1849 53.7643 53.9049 53.8979C58.2031 54.1087 80.6403 55.093 80.6403 55.093Z",
    fill: "url(#paint20_linear_8168_49027)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5104 54.9471H78.3576C78.3576 54.9471 78.7885 53.4416 77.8277 52.9729C76.8651 52.5043 72.5407 52.3331 72.0557 53.5752C71.7852 54.2696 72.5836 54.8417 74.2384 55.2464C75.8241 55.634 78.212 55.873 81.2604 55.937L80.5123 54.9471H80.5104Z",
    fill: "url(#paint21_linear_8168_49027)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9062 47.2995C68.4098 47.307 70.4619 47.3466 72.4375 47.7644L82.6384 47.2543C82.1235 47.1697 81.6198 47.1132 81.1273 47.0869C79.0715 46.9758 76.0194 46.9419 72.8573 47.0323C70.2865 47.1057 67.727 47.2995 64.9062 47.2995Z",
    fill: "url(#paint22_linear_8168_49027)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M98.0684 72.3592C118.289 74.418 124.037 70.2288 124.037 70.2288V68.7383C123.199 69.3104 122.018 69.9013 120.379 70.3398C115.911 71.533 109.432 69.9973 109.432 69.9973L98.2736 69.1071C98.3631 70.9214 98.0684 72.3611 98.0684 72.3611V72.3592Z",
    fill: "url(#paint23_linear_8168_49027)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1219 69.2358C62.1219 69.2358 61.5474 60.0913 61.9447 55.0947C62.3421 50.0981 63.8233 47.373 63.8233 47.373H64.3438C64.3438 47.373 63.1499 50.0981 62.7525 55.0947C62.3551 60.0913 62.7525 69.2358 62.7525 69.2358H62.1238H62.1219Z",
    fill: "url(#paint24_linear_8168_49027)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M86.3252 71.3343C86.1667 70.175 86.1163 69.0966 86.1741 68.1425L51.8272 65.4023C51.8067 66.9248 51.1836 68.2083 51.1836 68.2083L86.3271 71.3362L86.3252 71.3343Z",
    fill: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M51.1796 68.2042L86.3156 71.332C86.1123 71.2981 81.7655 70.5905 80.6387 69.7079C79.4858 68.8045 78.3926 68.0856 76.8498 68.0066C75.4636 67.9351 55.7465 66.3335 51.7822 66.0117C51.6423 67.2519 51.1777 68.2061 51.1777 68.2061L51.1796 68.2042Z",
    fill: "url(#paint25_linear_8168_49027)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M40.6363 64.6859C41.0785 66.0692 42.7146 66.9594 42.7146 66.9594C42.5019 66.2706 42.3098 65.211 42.3694 64.1101C42.3694 64.1101 40.6848 63.4796 40.4834 61.784C40.4834 61.7821 40.4834 61.7802 40.4834 61.7783C40.4143 63.0675 40.474 64.1797 40.6363 64.6859Z",
    fill: "url(#paint26_linear_8168_49027)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6327 57.8564C97.7483 58.0333 98.8826 58.2441 100.017 58.5001C101.396 58.8125 102.778 59.1908 104.13 59.6612C107.285 60.7565 110.307 64.2683 111.69 65.4031C112.117 65.3128 112.533 65.2243 112.94 65.1377C108.998 59.8927 102.244 58.7052 96.6309 57.8564H96.6327Z",
    fill: "url(#paint27_linear_8168_49027)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8168_49027",
    x: 18.0273,
    y: 6.33496,
    width: 144.885,
    height: 209.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.2617
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.2617
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8168_49027"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8168_49027",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8168_49027",
    x: 2.18945,
    y: 74.9092,
    width: 72.7109,
    height: 52.6553,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8168_49027"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_8168_49027",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8168_49027",
    x1: 8.54463,
    y1: 105.221,
    x2: 68.5816,
    y2: 87.2427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8168_49027",
    x1: 46.7247,
    y1: 109.031,
    x2: 63.9222,
    y2: 103.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8168_49027",
    x1: 40.1077,
    y1: 104.269,
    x2: 60.2333,
    y2: 98.2422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8168_49027",
    x1: 48.6027,
    y1: 89.4473,
    x2: 55.9777,
    y2: 87.2388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8168_49027",
    x1: 49.1446,
    y1: 65.7611,
    x2: 44.9747,
    y2: 60.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B50C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8168_49027",
    x1: 92.2285,
    y1: 66.8684,
    x2: 86.9155,
    y2: 65.5522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B50C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#188920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8168_49027",
    x1: 115.714,
    y1: 81.505,
    x2: 117.063,
    y2: 64.1946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8168_49027",
    x1: 97.3866,
    y1: 76.7413,
    x2: 95.6763,
    y2: 70.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8168_49027",
    x1: 91.5325,
    y1: 58.3305,
    x2: 92.3412,
    y2: 80.6162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8168_49027",
    x1: 93.5357,
    y1: 74.5393,
    x2: 92.3847,
    y2: 70.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8168_49027",
    x1: 51.439,
    y1: 71.831,
    x2: 50.0378,
    y2: 66.7447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8168_49027",
    x1: 47.0135,
    y1: 55.6128,
    x2: 46.8123,
    y2: 76.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2781B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104274"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8168_49027",
    x1: 48.2218,
    y1: 69.8795,
    x2: 47.3097,
    y2: 66.5619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C6E9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3965"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8168_49027",
    x1: 91.0665,
    y1: 47.9461,
    x2: 92.1504,
    y2: 60.8962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8168_49027",
    x1: 78.1515,
    y1: 53.7127,
    x2: 91.1023,
    y2: 49.2364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8168_49027",
    x1: 115.567,
    y1: 27.6786,
    x2: 68.762,
    y2: 77.6616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8168_49027",
    x1: 103.293,
    y1: 69.5021,
    x2: 103.984,
    y2: 60.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8168_49027",
    x1: 100.642,
    y1: 62.8866,
    x2: 106.038,
    y2: 61.0208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8168_49027",
    x1: 109.535,
    y1: 52.2369,
    x2: 68.5731,
    y2: 98.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8168_49027",
    x1: 65.7923,
    y1: 50.9021,
    x2: 65.3861,
    y2: 55.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8168_49027",
    x1: 61.078,
    y1: 47.4898,
    x2: 68.4168,
    y2: 58.6325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8EBF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8168_49027",
    x1: 76.4845,
    y1: 53.099,
    x2: 76.9496,
    y2: 58.6652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8168_49027",
    x1: 73.7322,
    y1: 46.7914,
    x2: 73.9069,
    y2: 48.8669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8168_49027",
    x1: 97.0703,
    y1: 62.8026,
    x2: 121.003,
    y2: 75.8278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8168_49027",
    x1: 64.314,
    y1: 43.0577,
    x2: 61.5237,
    y2: 69.6448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59CF1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8168_49027",
    x1: 69.1935,
    y1: 67.2802,
    x2: 68.148,
    y2: 73.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8168_49027",
    x1: 41.2184,
    y1: 60.683,
    x2: 41.9321,
    y2: 69.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEF7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8168_49027",
    x1: 103.796,
    y1: 74.4177,
    x2: 104.97,
    y2: 59.3786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59CF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B50C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8168_49027"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.5508,
    y: 23.5967,
    width: 56.8194,
    height: 104.52,
    rx: 6,
    fill: "white"
  })))));
};
export default SvgCarRentalsStep3;